import { render, staticRenderFns } from "./addAssemble.vue?vue&type=template&id=ab9af0ac&scoped=true&"
import script from "./addAssemble.vue?vue&type=script&lang=js&"
export * from "./addAssemble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9af0ac",
  null
  
)

export default component.exports